function isExtendedWorkflowContent(attachInfo) {
    return JSON.parse(attachInfo?.extended_attributes || "{}")?.workflow_extended_content?.length > 0;
}

export { isExtendedWorkflowContent }